"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTaskStatus = void 0;
function parseTaskStatus(status) {
    return !status.includes('/') ? status : status.split('/').pop() || '';
}
exports.parseTaskStatus = parseTaskStatus;
//# sourceMappingURL=parse-task-status.js.map